<template>
<div>

  <div class="row mb-md-3">

    <div class="col-md-12">
    <el-select
      :disabled="isLoading"
      ref="customerID"
      v-model="customerID"
      placeholder="Select Customer"
    >
      <el-option
          label="--- No filter ---"
          value=""
          style="margin-right: 10px"
        ></el-option>
      <el-option
          v-for="item in options.customers"
          :key="item.id"
          :label="`${item.thName} / ${item.enName}`"
          :value="item.id"
          style="margin-right: 10px"
        ></el-option>
      </el-select>

      <el-date-picker
        v-model="selectedDate"
        :disabled="isLoading === true"
        type="daterange"
        format="dd/MM/yyyy"
        value-format="yyyy-MM-dd"
        placeholder="Pick a shipment date"
        unlink-panels
        :picker-options="pickerOptions"
        @change="onChangeShipmentDate"
        start-placeholder="Start date"
        end-placeholder="End date">
        >
      </el-date-picker>
        <!-- <el-button
        type="primary"
        plain
        style="font-size: 24px;"
        :disabled="isLoading"
        :icon="`${isLoading ? 'el-icon-loading' : 'el-icon-refresh'}`"
        @click="refresh()">
        </el-button> -->
        <button class="btn btn-icon btn-neutral" :disabled="isLoading" @click="refresh()">
          <i class="el-icon-refresh" v-show="isLoading === false"></i>

          <span class="loading" v-show="isLoading === true" ><i class="el-icon-loading"></i></span>
        </button>
    </div>
  </div>

  <div class="row">
    <!-- {{datasets}} -->
    <div class="col-md-6">
      <card>
        <template slot="header">
          <h4 class="card-title">Shipments: <strong>{{summary.shipment}}</strong></h4>
          <p class="category">Total House Air Waybill</p>
        </template>
        <bar-chart :chart-data="dataShipmentsCollection"
                    :height="250"
        >
        </bar-chart>
      </card>
    </div>
    <div class="col-md-6">
      <card>
        <template slot="header">
          <h4 class="card-title">Categories: <strong>{{summary.category}}</strong></h4>
          <p class="category">Total Shipment by Category</p>
        </template>
        <bar-chart
                   :height="250"
                    :chart-data="dataCategoriesCollection">
        </bar-chart>
      </card>
    </div>
    <div class="col-md-6">
      <card>
        <template slot="header">
          <h4 class="card-title">Status: <strong>{{summary.status}}</strong></h4>
          <p class="category">Total Shipment by Status</p>
        </template>
        <bar-chart
                   :height="250"
                    :chart-data="dataStatusCollection">
        </bar-chart>
      </card>
    </div>
  </div>
</div>
</template>
<script>
  import Vue from "vue"
  import * as _apiCustomer from "@/api/customer"
  import { Card } from 'src/components/UIComponents'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard'
  import LineChart from 'src/components/UIComponents/Charts/LineChart'
  import BarChart from 'src/components/UIComponents/Charts/BarChart'
  import PieChart from 'src/components/UIComponents/Charts/PieChart'
  import * as _apiDashboard from "@/api/dashboard"
  import {
    Select,
    Option,
    DatePicker,
    // Button,
  } from "element-ui"

  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DatePicker)
  // Vue.use(Button)

  const tooltipOptions = {
    tooltipFillColor: "rgba(0,0,0,0.5)",
    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipFontSize: 14,
    tooltipFontStyle: "normal",
    tooltipFontColor: "#fff",
    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipTitleFontSize: 14,
    tooltipTitleFontStyle: "bold",
    tooltipTitleFontColor: "#fff",
    tooltipYPadding: 6,
    tooltipXPadding: 6,
    tooltipCaretSize: 8,
    tooltipCornerRadius: 6,
    tooltipXOffset: 10,
  };

  export default {
    components: {
      Card,
      ChartCard,
      LineChart,
      BarChart,
      PieChart
    },
    data() {
      return {
        customerID: '',
        options: {
          customers: []
        },
        summary: {
          shipment: 0,
          category: 0,
          status: 0,
        },
        isLoading: false,
        pickerOptions: {
          shortcuts: [{
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        selectedDate: '',
    	  dataShipmentsCollection: null,
        dataCategoriesCollection: null,
        dataStatusCollection: null
      }
    },
    created () {
			const today = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10)
      const past7Days = (new Date(Date.now() - 604800000-(new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10)
      this.selectedDate = [past7Days, today]
      this.fillShipmentsData(this.customerID, past7Days, today)
      this.getAllCustomer()
    },
    methods: {
      refresh () {
        this.fillShipmentsData(this.customerID, this.selectedDate[0], this.selectedDate[1])
      },
      getAllCustomer(){
        _apiCustomer.getAll()
        .then(response => {
          this.options.customers = response.data
        })
        .catch(error => {
          this.$notify({
            message: error.response.data.message || 'Unsuccessfully',
            type: 'danger'
          })
        });
      },
      onChangeShipmentDate(v) {
        this.fillShipmentsData(this.customerID, v[0], v[1])
      },
      fillShipmentsData (customerID, startDate, endDate) {
        let _this = this
        _this.isLoading = true

        _apiDashboard.getDataVolume(customerID, startDate, endDate)
        .then(response => {
          _this.reRenderDataShipments(response.data.shipments)
          _this.reRenderDataCategories(response.data.categories)
          _this.reRnderDataStatus(response.data.statusData)

        })
        .catch(error => {
          this.$notify({
            message: error.response.data.message || 'Unsuccessfully',
            type: 'danger'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },
      reRenderDataShipments (v) {
        let _this = this
        _this.summary.shipment = 0

        if (!v.labels) {
          v.labels = []
        }
        if (!v.data) {
          v.data = []
          _this.summary.shipment = 0
        }
        try {
          v.data.forEach(e => {
            _this.summary.shipment += e
          });

          _this.dataShipmentsCollection = {
            labels: v.labels || [],
            datasets: [
              {
                label: 'Shipments',
                backgroundColor:  'rgba(255, 99, 132, 1)',
                borderColor: 'rgba(255,99,132,1)',
                // backgroundColor: '#f96332',
                // borderColor: "#f96332",
                pointBorderColor: "#FFF",
                pointBackgroundColor: "#f96332",
                pointBorderWidth: 2,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 1,
                pointRadius: 4,
                fill: true,
                borderWidth: 1,
                data: v.data || []
              },
            // {
            //     label: "A",
            //     backgroundColor:  'rgba(255, 99, 132, 1)',
            //     borderColor: 'rgba(255,99,132,1)',
            //     data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
            // },
            // {
            //     label: "B",
            //     backgroundColor: 'rgba(75, 192, 192, 1)',
            //     borderColor: 'rgba(75, 192, 192, 1)',
            //     data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
            // },
            //  {
            //      label: "C",
            //      backgroundColor: 'rgba(255, 206, 86, 1)',
            //      borderColor: 'rgba(255, 206, 86, 1)',
            //     data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
            //  }
            ]
          }
        }
        catch(err) {
          console.log(err)
        }
      },
      reRenderDataCategories (v) {
        let _this = this
        let summaryCat1 = 0
        let summaryCat2 = 0
        let summaryCat3 = 0
        let summaryOther = 0

        try {
          if (v.labels) {
            v.data[0].data.forEach(e => {
              summaryCat1 += e
            });
            v.data[1].data.forEach(e => {
              summaryCat2 += e
            });
            v.data[2].data.forEach(e => {
              summaryCat3 += e
            });
            v.data[3].data.forEach(e => {
              summaryOther += e
            });
          }

          _this.summary.category = summaryCat1 + summaryCat2 + summaryCat3 + summaryOther

          _this.dataCategoriesCollection = {
            labels: v.labels || [],
            datasets: [
              {
                label: v.data[0].label + " ["+summaryCat1+"]",
                borderColor: '#fcc468',
                fill: true,
                backgroundColor: '#fcc468',
                hoverBorderColor: '#fcc468',
                borderWidth: 8,
                data: v.data[0].data || [],
              },
              {
                label: v.data[1].label + " ["+summaryCat2+"]",
                borderColor: '#4cbdd7',
                fill: true,
                backgroundColor: '#4cbdd7',
                hoverBorderColor: '#4cbdd7',
                borderWidth: 8,
                data: v.data[1].data || [],
              },
              {
                label: v.data[2].label + " ["+summaryCat3+"]",
                borderColor: '#F35B5B',
                fill: true,
                backgroundColor: '#F35B5B',
                hoverBorderColor: '#F35B5B',
                borderWidth: 8,
                data: v.data[2].data || [],
              },
              {
                label: v.data[3].label + " ["+summaryOther+"]",
                borderColor: '#41F475',
                fill: true,
                backgroundColor: '#41F475',
                hoverBorderColor: '#41F475',
                borderWidth: 8,
                data: v.data[3].data || [],
              }
            ],
            options: {
              tooltips: tooltipOptions
            }
          }
        } catch(err) {
          console.log(err)
        }
      },
      reRnderDataStatus (v) {
        let _this = this
        let summaryReady = 0
        let summaryReleased = 0
        let summaryHold = 0
        let summaryNoShow = 0
        let summaryOver = 0
        let summaryCat4 = 0
        let summaryUnmanifest = 0
        let summaryMismatched = 0

        try {
          if (v.labels) {
            v.data[0].data.forEach(e => {
              summaryReady += e
            });
            v.data[1].data.forEach(e => {
              summaryReleased += e
            });
            v.data[2].data.forEach(e => {
              summaryHold += e
            });
            v.data[3].data.forEach(e => {
              summaryNoShow += e
            });
            v.data[4].data.forEach(e => {
              summaryOver += e
            });
            v.data[5].data.forEach(e => {
              summaryCat4 += e
            });
            v.data[6].data.forEach(e => {
              summaryUnmanifest += e
            });
            v.data[7].data.forEach(e => {
              summaryMismatched += e
            });
          }

          _this.summary.status = summaryReady + summaryReleased + summaryHold + summaryNoShow + summaryOver + summaryCat4 + summaryUnmanifest + summaryMismatched

          _this.dataStatusCollection = {
            labels: v.labels || [],
            datasets: [
              {
                label: v.data[0].label + " ["+summaryReady+"]",
                borderColor: '#fcc468',
                fill: true,
                backgroundColor: '#fcc468',
                hoverBorderColor: '#fcc468',
                borderWidth: 8,
                data: v.data[0].data || [],
              },
              {

                label: v.data[1].label + " ["+summaryReleased+"]",
                borderColor: '#4cbdd7',
                fill: true,
                backgroundColor: '#4cbdd7',
                hoverBorderColor: '#4cbdd7',
                borderWidth: 8,
                data: v.data[1].data || [],
              },
              {

                label: v.data[2].label + " ["+summaryHold+"]",
                borderColor: '#F35B5B',
                fill: true,
                backgroundColor: '#F35B5B',
                hoverBorderColor: '#F35B5B',
                borderWidth: 8,
                data: v.data[2].data || [],
              },
              {

                label: v.data[3].label + " ["+summaryNoShow+"]",
                borderColor: '#41F475',
                fill: true,
                backgroundColor: '#41F475',
                hoverBorderColor: '#41F475',
                borderWidth: 8,
                data: v.data[3].data || [],
              },
              {

                label: v.data[4].label + " ["+summaryOver+"]",
                borderColor: '#AF089E',
                fill: true,
                backgroundColor: '#AF089E',
                hoverBorderColor: '#AF089E',
                borderWidth: 8,
                data: v.data[4].data || [],
              },
              {

                label: v.data[5].label + " ["+summaryCat4+"]",
                borderColor: '#A0A4D5',
                fill: true,
                backgroundColor: '#A0A4D5',
                hoverBorderColor: '#A0A4D5',
                borderWidth: 8,
                data: v.data[5].data || [],
              },
              {

                label: v.data[6].label + " ["+summaryUnmanifest+"]",
                borderColor: '#9E628C',
                fill: true,
                backgroundColor: '#9E628C',
                hoverBorderColor: '#9E628C',
                borderWidth: 8,
                data: v.data[6].data || [],
              },
              {

                label: v.data[7].label + " ["+summaryMismatched+"]",
                borderColor: '#6F7D60',
                fill: true,
                backgroundColor: '#6F7D60',
                hoverBorderColor: '#6F7D60',
                borderWidth: 8,
                data: v.data[7].data || [],
              }
            ],
            options: {
              tooltips: tooltipOptions
            }
          }
        } catch(err) {
          console.log(err)
        }
      }
    }
  }
</script>
<style>
</style>
